module.exports = function(data) {
var __t, __p = '';
__p += '<div class="overlay-sidebar"></div>\n<div class="overlay-wrapper">\n    <div class="topbar"></div>\n    <div class="subpage-top">\n        <div class="subpage-name"></div>\n        <div class="sdr-datepicker"></div>\n    </div>\n    <div class="overlay-content"></div>\n</div>\n';
return __p
}